import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordEducationListItem, RecordEducationListItem } from "./recordEducationListItem";

export interface IRecordEducationListItems extends ListItems<IRecordEducationListItem> { }

export class RecordEducationListItems extends ListItems<RecordEducationListItem> implements IRecordEducationListItems {
    constructor();
    constructor(obj: IRecordEducationListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordEducationListItem);
    }
}